<div class="add-role-card">
  <!-- Header -->
  <div class="card-header">
    <div class="title-text">Add Role</div>

    <div class="close-area" (click)="close()">
      <span class="close-icon">✕</span>
    </div>
  </div>

  <!-- Body -->
  <div class="card-body">
    <div class="form-row">
      <!-- Role Name -->
      <div class="field">
        <input
          class="input-box"
          type="text"
          placeholder="Role Name"
          [(ngModel)]="roleName"
        />
      </div>

      <!-- Role Color -->
      <div class="field">
        <div class="color-input-wrapper">
          <!-- Color block INSIDE the input like image 2 -->
          <span class="color-preview" [ngClass]="'rc-' + selectedColor"></span>

          <!-- Styled input that looks identical to Role Name -->
          <select
            class="color-input"
            [(ngModel)]="selectedColor"
            [ngModelOptions]="{ standalone: true }"
          >
            <option [ngValue]="null" disabled>
              Role Color
            </option>
            <option *ngFor="let c of colorOptions" [value]="c.value">
              {{ c.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- ACTION BUTTONS -->
    <div class="actions">
      <button class="btn-cancel" (click)="close()">CANCEL</button>
      <button class="btn-save" [disabled]="!roleName" (click)="save()">
        SAVE
      </button>
    </div>
  </div>
</div>
<wm-common-confirmation-modal
  [data]="confirmModal"
  (onYesClick)="onConfirmYes()"
  (onNoClick)="onConfirmNo()"
  (onOkClick)="onConfirmOk()"
  (onCloseClick)="onConfirmNo()"
  [isApplicantMobileview]="true"
></wm-common-confirmation-modal>
